export const NOTES_GET = 'NOTES_GET';
export const NOTE_GET = 'NOTE_GET';